export const GET_SINGLE_USE_TOKEN_REQUEST = 'GET_SINGLE_USE_TOKEN_REQUEST';
export const GET_SINGLE_USE_TOKEN_FAILURE = 'GET_SINGLE_USE_TOKEN_FAILURE';
export const GET_SINGLE_USE_TOKEN_SUCCESS = 'GET_SINGLE_USE_TOKEN_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/tokens/mutation-types.js